/** Пример значений данных получаемых из сервисов Liferay
 * Сервис http://62.61.8.56:8080/api/jsonws/dlfolder/get-folders-and-file-entries-and-file-shortcuts/group-id/20124/folder-id/0/status/0/include-mount-folders/true/start/0/end/1/-obc
 * {
 *    "companyId": "20101",
 *    "createDate": 1586377632087,
 *    "defaultFileEntryTypeId": "0",
 *    "description": "",
 *    "folderId": "37958",
 *    "groupId": "20124",
 *    "hidden": false,
 *    "lastPostDate": 1586378357869,
 *    "lastPublishDate": null,
 *    "modifiedDate": 1586377632087,
 *    "mountPoint": false,
 *    "mvccVersion": "3",
 *    "name": "Библиотека документов",
 *    "parentFolderId": "0",
 *    "repositoryId": "20124",
 *    "restrictionType": 0,
 *    "status": 0,
 *    "statusByUserId": "0",
 *    "statusByUserName": "",
 *    "statusDate": null,
 *    "treePath": "/37958/",
 *    "userId": "33501",
 *    "userName": "Test Test",
 *    "uuid": "8c7ff3f4-213d-0934-c39d-c5bb9f1b6885"
 *  }
 * 
 * 
 * Сервис http://62.61.8.56:8080/api/jsonws/dlfolder/get-folders-and-file-entries-and-file-shortcuts/group-id/20124/folder-id/37930/status/0/include-mount-folders/true/start/0/end/1/-obc
 * 
 * {
 *    "classNameId": "0",
 *    "classPK": "0",
 *    "companyId": "20101",
 *   "createDate": 1597868255841,
 *    "custom1ImageId": "0",
 *    "custom2ImageId": "0",
 *    "description": "",
 *    "extension": "pdf",
 *    "extraSettings": "",
 *    "fileEntryId": "61187",
 *    "fileEntryTypeId": "0",
 *    "fileName": "Постановление Главного государственного санитарно врач РФ от 10 ноября 1997 года N 25 Об использовании методологии оценки риска для управления качеством окружающей среды и здоровья населения в Российской Федерации.pdf",
 *    "folderId": "37930",
 *    "groupId": "20124",
 *    "largeImageId": "0",
 *    "lastPublishDate": null,
 *    "manualCheckInRequired": false,
 *    "mimeType": "application/pdf",
 *    "modifiedDate": 1597868278565,
 *    "mvccVersion": "4",
 *    "name": "1606",
 *    "readCount": 2,
 *    "repositoryId": "20124",
 *    "size": "80222",
 *    "smallImageId": "0",
 *    "title": "Постановление Главного государственного санитарно врач РФ от 10 ноября 1997 года N 25 Об использовании методологии оценки риска для управления качеством окружающей среды и здоровья населения в Российской Федерации",
 *    "treePath": "/37905/37930/",
 *    "userId": "33501",
 *    "userName": "Валентин Михайлович Семенов",
 *    "uuid": "555a9402-5a77-2ff7-264d-8fc080ba5f6b",
 *    "version": "1.0"
 *  }
 */
import { TEAMWORK } from '../../const/C';



/** Формируется URL на страницу в Liferay */
export const makeURL = selected => {
  const url = "http://62.61.8.56:8080/documents/"+selected.groupId+"/"+selected.folderId+"/"+selected.fileName+"/"+selected.uuid;
  return encodeURI(url);
}

